// extracted by mini-css-extract-plugin
module.exports = {"info":"FilterInfo_info__1o-VB","container":"FilterInfo_container__15DF0","boldText":"FilterInfo_boldText__19-vM","children":"FilterInfo_children__2HxHk"};